import timeGridPlugin from "@fullcalendar/timegrid";

export default timeGridPlugin;
